import { camelCase, map } from 'lodash/fp';

import { Rate } from '../../../../../../../types/__codegen__/sanity/graphql';
import formatSanityBrackets from '../format-sanity-brackets';

const getScaleTableData = (taxScaleBrackets: Rate | null) => {
  if (!taxScaleBrackets) {
    return {};
  }

  const columns = map('bracketType', taxScaleBrackets?.brackets);
  const data = formatSanityBrackets(taxScaleBrackets);

  return {
    columns: {
      ...map(
        (column) => ({
          colProps: {
            df: 4,
            sm: 4,
          },
          header: column.title,
          key: camelCase(column.name),
        }),
        columns,
      ),
      mls: {
        colProps: {
          df: 3,
        },
        header: 'Medicare Levy Surcharge',
        key: 'mls',
      },
    },
    data,
    variant: ['rowBorders', 'rowPadding'],
  };
};

export default getScaleTableData;
